import React from 'react'
import { Toaster } from 'sonner'
import { useTheme } from '@/contexts/ThemeContext'

interface EmptyLayoutProps {
  children: React.ReactNode
}

export default function EmptyLayout({ children }: EmptyLayoutProps) {
  const { theme } = useTheme()

  return (
    <div className="min-h-screen bg-background">
      {children}
      <Toaster
        position="bottom-center"
        richColors
        theme={theme}
        toastOptions={{
          style: {
            background: 'var(--card)',
            border: '1px solid var(--border)',
            color: 'var(--foreground)',
          },
        }}
      />
    </div>
  )
}
